import call from "../../../assets/call.png";
import "./index.css"

import React from "react";

const GetInTouch = () => {
  return (
    <>
      <section class="section cta" style={{ padding: "70px 5% 20px" }}>
        <div class="container">
          <div class="cta-grid">
            <div id="w-node-_86b659df-b93d-dfa6-9d4f-1ba273b772a1-b3f3b9f1">
              <div
                data-w-id="fa71ff7b-a743-caff-afb8-eee0fadab731"
                class="flex-tag left"
              >
                <div class="bullet-tag color"></div>
              </div>
              <p
                data-w-id="18ba4034-317d-2032-900e-6ad3a2a3c752"
                class="subhead-main for-title"
              >
                Your migration journey is simplified and stress-free with expert
                guidance every step of the way.
               
              </p>
              <div class="margin-50px">
                <div
                  data-w-id="184e3440-d179-02c4-acef-ebc5b3f3b9fa"
                  class="button-flex"
                >
                  <a
                    href="tel:+61 423 439 693"
                    class="button-underline white w-inline-block"
                  >
                    <div class="button-color cta">Get in Touch</div>
                    <div class="line-animation">
                      <div class="underline"></div>
                    </div>
                  </a>
                  <div class="div-block">
                    <a
                      href="tel:+61 423 439 693"
                      class="phone-flex w-inline-block"
                    >
                      <div class="phone-circle">
                        <img src={call} loading="lazy" width="18" alt="" />
                      </div>
                      <p class="top-text">
                        <span class="other-color">Call us:</span> +61 423 439
                        693
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="w-node-ac020a97-0540-9722-7fe1-cec7ba73d935-b3f3b9f1"
              data-w-id="ac020a97-0540-9722-7fe1-cec7ba73d935"
              class="photo-center"
            ></div>
          </div>
        </div>
        <div class="background-overlay"></div>
      </section>
    </>
  );
};

export default GetInTouch;
